import { humanRigs, type HumanProportions, type HumanRigId } from './human.js';
import { ORC_FACE_DEFAULT, orcFaceShape, orcSkull, resolveOrcFace, type OrcFaceMorph } from './orc-face.js';

export type OrcRigId = 'orc-male' | 'orc-female';
export interface OrcProportions extends HumanProportions { faceMorph: OrcFaceMorph }
export const ORC_RIG_VERSION = 2;

/** The compatible body frame has its own muscularity; the head is independently authored Orc anatomy. */
function proportions(id: OrcRigId, motionRig: HumanRigId): OrcProportions {
  const p = structuredClone(humanRigs[motionRig]); p.id = id;
  p.muscularity = motionRig === 'human-male' ? .9 : .8; p.muscleDefinition = .8;
  p.shoulderHalfWidth *= 1.04; p.pelvisHalfWidth *= 1.06; p.handScale *= 1.08; p.headScale *= 1.035;
  const faceMorph = { ...ORC_FACE_DEFAULT, ...motionRig === 'human-female' ? { brow: .011, tuskLength: .033, tuskRadius: .0063 } : {} };
  const face = orcFaceShape(faceMorph, motionRig);
  return { ...p, faceMorph, face, skull: orcSkull(faceMorph, motionRig), faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headMeshCell: .0035 };
}
export const orcRigs: Record<OrcRigId, OrcProportions> = {
  'orc-male': proportions('orc-male', 'human-male'),
  'orc-female': proportions('orc-female', 'human-female'),
};
export function orcProportions(rig = 'orc-male'): OrcProportions {
  if (!(rig in orcRigs)) throw new Error(`No Orc builder registered for rig '${rig}'.`);
  return orcRigs[rig as OrcRigId];
}
/** A chosen face resolves all its anatomy together, including its mouth, underbite and tusks. */
export function morphOrcProportions(source: OrcProportions, faceId = 'standard'): OrcProportions {
  const faceMorph = resolveOrcFace(source.faceMorph, faceId), face = orcFaceShape(faceMorph, source.motionRig);
  return { ...source, faceMorph, face, skull: orcSkull(faceMorph, source.motionRig),
    faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headCacheKey: `${source.id}:${faceId}:${JSON.stringify(faceMorph)}` };
}
export const orcStandardHeight = (rig: string) => rig === 'orc-female' ? 1.85 : 1.95;
